import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation(); // Destructure pathname and search

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top
  }, [pathname, search]);  // Trigger effect when either the path or search query changes

  return null;  // This component doesn't render anything visible
};

export default ScrollToTop;
